// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navbar_nav__f8XJ6","content":"Navbar_content__3phGc","menu":"Navbar_menu__3JiP_"};